import e, { Component as t } from "react";
import { GroupedList as r } from "./SelectableListGrouped.js";
import { next as n, previous as o } from "./helpers.js";
function a(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function l(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function i(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function c(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function u(e) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function s(e, t) {
  return (s = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function f(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r,
      n,
      o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != o) {
      var a = [],
        l = !0,
        i = !1;
      try {
        for (o = o.call(e); !(l = (r = o.next()).done) && (a.push(r.value), !t || a.length !== t); l = !0);
      } catch (e) {
        i = !0, n = e;
      } finally {
        try {
          l || null == o.return || o.return();
        } finally {
          if (i) throw n;
        }
      }
      return a;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return a(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return a(e, t);
    }
  }(e, t) || function () {
    throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var p = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && s(e, t);
  }(y, t);
  var a,
    p,
    d,
    h = (a = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        r = u(y);
      if (a) {
        var n = u(this).constructor;
        t = Reflect.construct(r, arguments, n);
      } else t = r.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : l(this);
    });
  function y() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, y), e = h.apply(this, arguments), c(l(e), "state", {
      selectedPath: []
    }), c(l(e), "next", function (t) {
      var r, o;
      null === (r = (o = e.props).onKeyboardEvent) || void 0 === r || r.call(o, t), 0 === e.state.selectedPath.length ? e.setSelectedPath([0, 0]) : e.setSelectedPath(n(e.props.groups, e.state.selectedPath));
    }), c(l(e), "previous", function (t) {
      var r,
        n,
        a = e.props.groups;
      null === (r = (n = e.props).onKeyboardEvent) || void 0 === r || r.call(n, t), 0 === e.state.selectedPath.length ? e.setSelectedPath([a.length - 1, a[a.length - 1].items.length - 1]) : e.setSelectedPath(o(a, e.state.selectedPath));
    }), c(l(e), "selectedFn", function (t, r) {
      var n;
      return r.join(",") === (null === (n = e.state.selectedPath) || void 0 === n ? void 0 : n.join(","));
    }), c(l(e), "setSelectedPath", function (t) {
      return e.setState({
        selectedPath: t
      });
    }), c(l(e), "handleEnter", function (t) {
      var r;
      if ((null === (r = e.state.selectedPath) || void 0 === r ? void 0 : r.length) > 0) {
        var n,
          o,
          a = f(e.state.selectedPath, 2),
          l = a[0],
          i = a[1],
          c = e.props.groups[l].items[i];
        return null === (n = (o = e.props).onKeyboardEvent) || void 0 === n || n.call(o, t), e.props.onItemPicked(c, e.state.selectedPath);
      }
    }), c(l(e), "handleClick", function (t, r, n) {
      e.props.onItemPicked(t, r, n), e.setSelectedPath(r);
    }), e;
  }
  return p = [{
    key: "componentDidUpdate",
    value: function value() {
      var e,
        t,
        r = f(this.state.selectedPath, 2),
        n = r[0],
        o = r[1];
      void 0 === (null === (t = this.props.groups[n]) || void 0 === t ? void 0 : null === (e = t.items) || void 0 === e ? void 0 : e[o]) && (0 !== n || 0 !== o) && this.setState({
        selectedPath: [0, 0]
      });
    }
  }, {
    key: "render",
    value: function value() {
      var t = this.props,
        n = t.groups,
        o = t.className,
        a = t.template;
      return e.createElement(r, {
        template: a,
        className: o,
        enableKeyboardNavigation: this.props.enableKeyboardNavigation,
        onNext: this.next,
        onPrevious: this.previous,
        onEnter: this.handleEnter,
        onClick: this.handleClick,
        isSelectedFn: this.selectedFn,
        groups: n
      });
    }
  }], i(y.prototype, p), d && i(y, d), y;
}(t);
export { p as SelectableListGroupedStateful };